import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { useCookies } from 'react-cookie';
import { usePOS } from '../../../contexts/POSContext';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';

const POSFullscreenPromptModal = ({ open, onClose }) => {
  const { isDarkMode } = usePOS();
  const [cookies, setCookie] = useCookies(['duzz_pdv_fullscreen_pref']);
  const [rememberChoice, setRememberChoice] = React.useState(true);

  const handleActivateFullscreen = () => {
    if (rememberChoice) {
      setCookie('duzz_pdv_fullscreen_pref', 'always', {
        path: '/',
        maxAge: 60 * 60 * 24 * 365,
      });
    }
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.warn('Erro ao solicitar tela cheia:', err);
      });
    }
    onClose();
  };

  const handleDismiss = () => {
    if (rememberChoice) {
      setCookie('duzz_pdv_fullscreen_pref', 'never', {
        path: '/',
        maxAge: 60 * 60 * 24 * 365,
      });
    }
    onClose();
  };

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleActivateFullscreen();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        handleDismiss();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, rememberChoice]);

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: isDarkMode ? 'pos-dark-paper' : '' }}
    >
      <UIDialogTitle onClose={handleDismiss}>
        Modo Tela Cheia (PDV)
      </UIDialogTitle>

      <DialogContent dividers style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 12, padding: '20px 16px' }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: isDarkMode ? 'rgba(56, 189, 248, 0.15)' : '#e3f2fd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: isDarkMode ? '#38bdf8' : '#17497F',
          }}
        >
          <FullscreenIcon style={{ fontSize: 34 }} />
        </div>

        <div style={{ fontSize: '1rem', fontWeight: 700, color: isDarkMode ? '#f8fafc' : '#212121' }}>
          Deseja ativar a Tela Cheia?
        </div>

        <p style={{ margin: 0, fontSize: '0.85rem', color: isDarkMode ? '#94a3b8' : '#616161', lineHeight: 1.5 }}>
          O Modo PDV é projetado para operar em tela cheia, garantindo máxima área de trabalho e foco na operação de caixa.
        </p>

        <FormControlLabel
          control={
            <Checkbox
              checked={rememberChoice}
              onChange={(e) => setRememberChoice(e.target.checked)}
              color="primary"
              size="small"
            />
          }
          label={
            <span style={{ fontSize: '0.8rem', color: isDarkMode ? '#cbd5e1' : '#616161' }}>
              Lembrar minha escolha nas próximas vezes
            </span>
          }
          style={{ marginTop: 4 }}
        />
      </DialogContent>

      <DialogActions style={{ padding: '10px 16px', justifyContent: 'space-between' }}>
        <Button
          onClick={handleDismiss}
          style={{ color: isDarkMode ? '#94a3b8' : '#757575', textTransform: 'none', fontSize: '0.82rem' }}
        >
          Continuar em Janela [Esc]
        </Button>

        <Button
          variant="contained"
          onClick={handleActivateFullscreen}
          autoFocus
          style={{
            backgroundColor: '#17497F',
            color: '#ffffff',
            fontWeight: 700,
            textTransform: 'none',
            fontSize: '0.85rem',
            padding: '6px 16px',
          }}
        >
          Ativar Tela Cheia [Enter]
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default POSFullscreenPromptModal;
